import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { observer } from 'mobx-react-lite';
import globalPaymentServices from '../../../../../../stores/global-payment-services';
import { PaymentServiceWithVersionsResponseType } from '../../../../../../api/types/payments/payment-template';
import appApi from '../../../../../../api/app-api';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import dateFormat from '../../../../../../utils/date-format';
import { CheckStatusType } from '../../../../../../api/types/students/payment-services/user-payments/user-payment-service-with-price-list';

export interface DialogAddCheckPaymentServiceModel {
  closeDialog: () => void;
}

export const DialogAddCheckPaymentService: React.FC<DialogAddCheckPaymentServiceModel> =
  observer(({ closeDialog }) => {
    const [selectedService, setSelectedService] =
      useState<PaymentServiceWithVersionsResponseType | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
      const fetchPaymentServices = async () => {
        try {
          const response = await appApi.getAllPaymentServices();
          globalPaymentServices.services = response.data.body;
        } catch (error) {
          console.error('Error fetching payment services:', error);
        }
      };

      fetchPaymentServices();
    }, []);

    const handleApprove = async () => {
      if (!selectedService) {
        toast.warn('אנא בחר שרות תשלום');
        return;
      }

      try {
        setLoading(true);
        const res = await appApi.addCheckStatusPaymentService(
          selectedService.id,
          CheckStatusType.BOUNCED,
        );

        if (res.data.ok) {
          await globalSettingsStores.fetchSetting();
          toast.success('השרות נוסף בהצלחה');
          closeDialog();
        } else if (res.data.errCode) {
          toast.warn(displayErrorText(res.data.errCode));
        }
      } catch (e) {
        console.error('Error adding check payment service:', e);
        toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
      } finally {
        setLoading(false);
      }
    };

    const isApproveDisabled = !selectedService || loading;

    return (
      <div>
        <DataTable
          emptyMessage={
            <div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>
          }
          selectionMode="single"
          value={globalPaymentServices.services}
          selection={selectedService}
          onSelectionChange={(e) => {
            setSelectedService(
              e.value as PaymentServiceWithVersionsResponseType,
            );
          }}
          dataKey="id"
          tableStyle={{
            direction: 'rtl',
            marginTop: '16px',
          }}
        >
          <Column selectionMode="single" headerStyle={{ width: '3rem' }} />
          <Column
            style={{ textAlign: 'right', width: '200px' }}
            field="paymentServiceName"
            header="שם שרות"
          />
          <Column
            body={(data: PaymentServiceWithVersionsResponseType) => (
              <div>₪{data.versions[0]?.price || 0}</div>
            )}
            header="מחיר"
            style={{ textAlign: 'right' }}
          />
          <Column
            field="createdByName"
            header="נוצר ע״י"
            style={{ textAlign: 'right' }}
          />
          <Column
            field="createdAt"
            header="תאריך יצירה"
            style={{ textAlign: 'right' }}
            body={(rowData: PaymentServiceWithVersionsResponseType) =>
              rowData.createdAt
                ? dateFormat.displayFormatDate(new Date(rowData.createdAt))
                : ''
            }
          />
        </DataTable>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            marginTop: '16px',
          }}
        >
          <Button
            label="אישור"
            onClick={handleApprove}
            disabled={isApproveDisabled}
            loading={loading}
          />
        </div>
      </div>
    );
  });
